export const OPERATION_STATUS_MESSAGE = {
  SHORT_THEME: {
    COMPLETED: 'Themes successfully tagged to responses',
    CREATED: 'Started thematic analysis',
    THEME_GENERATION: 'Identifying relevant themes from responses',
    CLASSIFICATION: 'Tagging themes to responses',
    FAILED: 'Some error occurred while tagging themes',
    DEFAULT: 'Tagging themes to responses',
    THEME_SUMMARY: 'Generating theme summary',
  },
  EXCEL_IMPORT: {
    DOWNLOADING: 'Downloading file',
    PARSING: 'Parsing file',
    PROCESSING: 'Processing columns',
    PROCESSING_USERS: 'Processing users',
    PROCESSING_ANSWERS: 'Processing answers',
    INSERTING_ANSWERS: 'Inserting answers',
    FINALIZING: 'Finalizing data',
    TRANSLATING: 'Translating transcripts',
    DONE: 'Excel import completed',
    FAILED: 'Excel import failed',
    DEFAULT: 'Importing excel data',
  },
  Reels: {
    INPROGRESS: 'Exporting reel',
    DONE: 'Reels successfully exported',
    FAILED: 'Some error occurred while exporting reels',
    DEFAULT: 'Exporting reel',
  },
  LONG_THEME: {
    TRANSCODING: 'Preparing media files',
    TRANSCRIPTION: 'Generating transcript',
    THEME_GENERATION: 'Performing thematic analysis',
    VIDEO_SUMMARY: 'Generating overall summary',
    COMPLETED: 'Themes successfully tagged to responses',
    FAILED: 'Some error occurred while processing media',
    DEFAULT: 'Performing thematic analysis',
  },
  LONG_CLUSTER: {
    CREATED: 'Generating universal themes',
    CLUSTERING: 'Generating universal themes',
    FINAL_THEME_SUMMARY: 'Generating theme summary',
    DEFAULT: 'Generating universal themes',
    FaILED: 'Some error occurred while generating universal themes',
    COMPLETED: 'Universal themes successfully generated',
  },
  FILE_DOWNLOAD: {
    CREATED: 'Zip file generation started',
    INPROGRESS: 'Generating files',
    DONE: 'Ready to download',
    FAILED: 'Some error occurred while generating files',
    DEFAULT: 'Generating files',
  },
};
